<template>
  <div class="accordion" :class="{ border: hasBorder }">
    <div class="accordion-header" @click="toggle">
      <!-- @slot Header -->
      <slot />
      <span class="toggle-icon" :class="{ custom: hasToggleIcon }">
        <!-- @slot Toggle icons if they are not + or - -->
        <slot
          v-if="hasToggleIcon"
          name="toggle-icon"
          :toggledClass="toggledClass"
        >
          <span :class="toggledClass" />
        </slot>
      </span>
    </div>
    <transition name="slide">
      <!-- @slot Content within accordion which gets expanded or collapsed -->
      <slot v-if="expanded" name="content" />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    /** To choose whether the accordion is expanded or collapsed */
    initialExpanded: {
      default: true,
      type: Boolean
    },
    hasBorder: {
      default: false,
      type: Boolean
    },
    hasToggleIcon: {
      default: true,
      type: Boolean
    }
  },

  data() {
    return {
      expanded: this.initialExpanded
    }
  },

  computed: {
    toggledClass() {
      return this.expanded ? 'collapse' : 'expand'
    }
  },

  methods: {
    toggle() {
      this.expanded = !this.expanded
      this.$emit('toggled', this.expanded)
    }
  }
}
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid $grey;
  border-bottom: none;
}

.slide-enter-active {
  transition-duration: 0.8s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.8s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-delay: -0.3s;
}

.slide-enter-to,
.slide-leave {
  max-height: 3000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.accordion-header {
  position: relative;
  cursor: pointer;
}

.toggle-icon {
  color: $grey;
  font-size: 24px;
  font-weight: 400;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translate(0, -50%);

  .expand:after {
    content: '+';
  }

  .collapse:after {
    content: '\2013';
  }

  &.custom {
    .expand:after,
    .collapse:after {
      content: '';
    }
  }
}
</style>
